<template>
  <div id="products">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.sn')">
          <el-input v-model="searchForm.sn"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.aoralLevel')">
          <el-input v-model="searchForm.aoralLevel"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.uploadBetween')">
          <el-date-picker
            v-model="searchForm.period"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            :start-placeholder="$t('cmsg.from')"
            :end-placeholder="$t('cmsg.to')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
          <el-button
            v-if="perms.indexOf('dental.add_aoralscan') > -1"
            type="primary"
            @click="onNew"
          >{{$t('cmsg.new')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
        <el-table-column :label="$t('cmsg.sn')">
          <template slot-scope="scope">
            {{scope.row.SerialNum}}
            <el-popover trigger="click" placement="top" v-if="scope.row.Comments != ''" width="450">
              <p>{{scope.row.Comments}}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">See More</el-tag>
              </div>
            </el-popover>
            <!-- <i class="el-icon-3d-delete icon-action" @click="deleteAoralscan(scope.row)"
            v-if="$gf.hasPerm('dental.delete_aoralscan')"></i>-->
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.scanSerialNum')">
          <template slot-scope="scope">
            <el-tag
              v-for="i in scope.row.ScanSerialNum"
              :key="i"
              v-if="scope.row.ScanSerialNum.length > 0"
            >{{i}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Level" :label="$t('cmsg.aoralLevel')"></el-table-column>
        <el-table-column prop="DogSerialNum" :label="$t('cmsg.dogSerialNum')"></el-table-column>
        <el-table-column prop="CameraSerialNum" :label="$t('cmsg.cameraSerialNum')"></el-table-column>
        <el-table-column prop="LightSerialNum" :label="$t('cmsg.lightSerialNum')"></el-table-column>
        <el-table-column prop="CalibrationSerialNum" :label="$t('cmsg.serialCalibration')"></el-table-column>
        <el-table-column :label="$t('cmsg.createOn')">
          <template slot-scope="scope">
            {{scope.row.CreateOn}}
            <span v-if="scope.row.CreateBy.NickName">
              <br />
              {{$t('cmsg.createBy')}}: {{scope.row.CreateBy.NickName}}
            </span>
            <span v-if="scope.row.ChangeBy.NickName">
              <br />
              {{$t('cmsg.updateBy')}}: {{scope.row.ChangeBy.NickName}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>

      <el-dialog
        :title="$t('cmsg.newProduct')"
        :visible.sync="sp.visible"
        :close-on-click-modal="sp.modelClose"
        :close-on-press-escape="sp.modelClose"
        width="80%"
        center
      >
        {{$t("cmsg.editProductHint")}}
        <br />>
        <el-form :model="sp.editData" size="mini" ref="productsEdit">
          <el-form-item :label="$t('cmsg.serialNumber')" prop="serialNum" required>
            <el-input v-model="sp.editData.serialNum" :placeholder="$t('cmsg.serialNumber')" />
          </el-form-item>
          <el-form-item :label="$t('cmsg.aoralLevel')" prop="level">
            <el-input v-model="sp.editData.level" :placeholder="$t('cmsg.aoralLevel')" />
          </el-form-item>
          <el-form-item :label="$t('cmsg.lightSerialNum')" prop="lightSerialNum">
            <el-input
              v-model="sp.editData.lightSerialNum"
              :placeholder="$t('cmsg.lightSerialNum')"
            />
          </el-form-item>
          <el-form-item :label="$t('cmsg.cameraSerialNum')" prop="cameraSerialNum">
            <el-input
              v-model="sp.editData.cameraSerialNum"
              :placeholder="$t('cmsg.cameraSerialNum')"
            />
          </el-form-item>
          <el-form-item :label="$t('cmsg.dogSerialNum')" prop="dogSerialNum">
            <el-input v-model="sp.editData.dogSerialNum" :placeholder="$t('cmsg.dogSerialNum')" />
          </el-form-item>
          <el-form-item :label="$t('cmsg.serialCalibration')" prop="calibrationSerialNum">
            <el-input
              v-model="sp.editData.calibrationSerialNum"
              :placeholder="$t('cmsg.serialCalibration')"
            />
          </el-form-item>
          <el-card>
            <div slot="header" class="clearfix">
              <span>{{$t('cmsg.scanSerialNum')}}</span>
              <el-button
                type="text"
                @click="addScanHeadItems"
                style="float:right;padding-top:0px;"
              >{{$t('cmsg.add')}}</el-button>
            </div>
            <div v-for="(i,k) in sp.editData.items" :key="k" style="margin-bottom: 10px;">
              <el-input
                class="sn_items_input"
                v-model="sp.editData.items[k]"
                maxlength="32"
                ref="scanHeadItems"
              >
                <el-button slot="append" icon="el-icon-delete" @click="removeScanHeadItems(k)"></el-button>
              </el-input>
            </div>
          </el-card>
          <el-form-item :label="$t('cmsg.comments')" prop="comments">
            <el-input
              type="textarea"
              v-model="sp.editData.comments"
              :placeholder="$t('cmsg.comments')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">{{$t('cmsg.cancel')}}</el-button>
          <el-button type="primary" @click="submitSP" :loading="sp.loading">{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  components: {},
  data() {
    return {
      searchForm: {
        sn: "",
        level: "",
        period: []
      },
      sp: {
        visible: false,
        loading: false,
        modelClose: false,

        editData: {
          serialNum: "",
          comments: "",
          scanSerialNum: "",
          lightSerialNum: "",
          cameraSerialNum: "",
          dogSerialNum: "",
          scanSNItem: "",
          level: "",
          items: [],
          calibrationSerialNum: ""
        }
      }
    };
  },
  watch: {
    "sp.editData.items": function(v) {
      console.log(v);
      this.sp.editData.scanSerialNum = v
        .map(item => {
          var s = item.trim();
          console.log(s);
          if (s !== "") {
            return '"' + s + '"';
          }
        })
        .join(",");
      console.log(this.sp.editData.scanSerialNum);
    }
  },
  methods: {
    submitSP() {
      if (
        this.sp.editData.scanSerialNum === "" &&
        this.sp.editData.lightSerialNum === "" &&
        this.sp.editData.cameraSerialNum === "" &&
        this.sp.editData.dogSerialNum === "" &&
        this.sp.editData.calibrationSerialNum === "" &&
        this.sp.editData.items.length < 1
      ) {
        this.$message({
          type: "error",
          message: this.$t("cmsg.editProductNotValid")
        });
        return false;
      }
      this.sp.loading = true;
      this.$refs.productsEdit.validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/u/dental/aoralscan/add", this.sp.editData, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.editProductHintSuccess")
                });

                this.sp.visible = false;
                this.closeDialog();
              }

              this.sp.loading = false;
              var t = this;
              setTimeout(function() {
                window.location = t.$router.resolve({
                  name: "products",
                  query: t.$route.query
                }).href;
              }, 3000);
            })
            .catch(res => (this.sp.loading = false));
        } else {
          this.sp.loading = false;
          return false;
        }
      });
    },
    onNew() {
      this.sp = {
        visible: true,
        loading: false,
        modelClose: false,

        editData: {
          serialNum: "",
          comments: "",
          scanSerialNum: "",
          lightSerialNum: "",
          cameraSerialNum: "",
          dogSerialNum: "",
          scanSNItem: "",
          level: "",
          items: [],
          calibrationSerialNum: ""
        }
      };
    },
    closeDialog() {
      this.sp = {
        visible: false,
        loading: false,
        modelClose: false,

        editData: {
          serialNum: "",
          comments: "",
          scanSerialNum: "",
          lightSerialNum: "",
          cameraSerialNum: "",
          dogSerialNum: "",
          scanSNItem: "",
          level: "",
          items: [],
          calibrationSerialNum: ""
        }
      };
    },
    removeScanHeadItems(k) {
      this.sp.editData.items.splice(k, 1);
    },
    addScanHeadItems() {
      this.sp.editData.items.unshift("");
    },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        sn: "",
        level: "",
        period: []
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["sn"]) {
        this.searchForm.sn = queryObj["sn"];
      }
      if (queryObj["level"]) {
        this.searchForm.level = queryObj["level"];
      }
      if (queryObj["start_on"]) {
        this.searchForm.period[0] = queryObj["start_on"];
      }
      if (queryObj["end_on"]) {
        this.searchForm.period[1] = queryObj["end_on"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["sn"] = this.searchForm.sn;
      queryObj["level"] = this.searchForm.level;
      queryObj["start_on"] = this.searchForm.period[0];
      queryObj["end_on"] = this.searchForm.period[1];
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "products",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "products",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "products",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:", pub.cdnUrl);
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.products")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/dental/aoralscan/list", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result.map(item => {
            if (item.ScanSerialNum.indexOf(",") > -1) {
              item.ScanSerialNum = item.ScanSerialNum.split(",").map(ssn => {
                console.log(ssn);
                var d = ssn.replace(/\"/g, "");
                if (d.trim() !== "") {
                  return d.trim();
                }
              });
            } else {
              item.ScanSerialNum = item.ScanSerialNum.trim();
              if (item.ScanSerialNum === "") {
                item.ScanSerialNum = [];
              } else {
                item.ScanSerialNum = [item.ScanSerialNum.replace(/\"/g, "")];
              }
            }
            console.log(item.ScanSerialNum);
            return item;
          });
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log("perms: ",perms);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#products {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
